export default {
  akron: 'akron',
  albuquerque: 'albuquerque',
  anaheim: 'anaheim',
  anchorage: 'anchorage',
  arlington: 'arlington',
  atlanta: 'atlanta',
  aurora: 'aurora',
  austin: 'austin',
  bakersfield: 'bakersfield',
  baltimore: 'baltimore',
  'baton rouge': 'baton-rouge',
  boston: 'boston',
  brooklyn: 'new-york',
  buffalo: 'buffalo',
  chandler: 'chandler',
  charlotte: 'charlotte',
  chesapeake: 'chesapeake',
  chicago: 'chicago',
  'chula vista': 'chula-vista',
  cincinnati: 'cincinnati',
  cleveland: 'cleveland',
  'colorado springs': 'colorado-springs',
  columbus: 'columbus',
  'corpus christi': 'corpus-christi',
  dallas: 'dallas',
  denver: 'denver',
  detroit: 'detroit',
  durham: 'durham',
  'el paso': 'el-paso',
  'fort worth': 'fort-worth',
  fremont: 'fremont',
  fresno: 'fresno',
  garland: 'garland',
  glendale: 'glendale',
  greensboro: 'greensboro',
  henderson: 'henderson',
  hialeah: 'hialeah',
  honolulu: 'honolulu',
  houston: 'houston',
  indianapolis: 'indianapolis',
  jacksonville: 'jacksonville',
  'jersey city': 'jersey-city',
  kalamazoo: 'kalamazoo',
  'kansas city': 'kansas-city',
  laredo: 'laredo',
  'las vegas': 'las-vegas',
  lexington: 'lexington',
  lincoln: 'lincoln',
  'long beach': 'long-beach',
  'los angeles': 'los-angeles',
  louisville: 'louisville',
  lubbock: 'lubbock',
  madison: 'madison',
  memphis: 'memphis',
  mesa: 'mesa',
  miami: 'miami',
  milwaukee: 'milwaukee',
  minneapolis: 'minneapolis',
  modesto: 'modesto',
  montgomery: 'montgomery',
  nashville: 'nashville',
  'new orleans': 'new-orleans',
  'new york': 'new-york',
  newark: 'newark',
  norfolk: 'norfolk',
  oakland: 'oakland',
  'oklahoma city': 'oklahoma-city',
  omaha: 'omaha',
  orlando: 'orlando',
  philadelphia: 'philadelphia',
  phoenix: 'phoenix',
  pittsburgh: 'pittsburgh',
  plano: 'plano',
  portland: 'portland',
  raleigh: 'raleigh',
  reno: 'reno',
  riverside: 'riverside',
  rochester: 'rochester',
  sacramento: 'sacramento',
  'san antonio': 'san-antonio',
  'san diego': 'san-diego',
  'san francisco': 'san-francisco',
  'san jose': 'san-jose',
  'santa ana': 'santa-ana',
  scottsdale: 'scottsdale',
  seattle: 'seattle',
  shreveport: 'shreveport',
  'st. louis': 'st-louis',
  'st. paul': 'st-paul',
  'st. petersburg': 'st-petersburg',
  stockton: 'stockton',
  tampa: 'tampa',
  toledo: 'toledo',
  tucson: 'tucson',
  tulsa: 'tulsa',
  'virginia beach': 'virginia-beach',
  washington: 'dc',
  wichita: 'wichita',
};
